import { printPrice } from '@niaratech/niara-js-commons';
import type { AddonReservation } from 'src/types';
import fillCrudMetadataGaps, { PartialField } from '../../fillCrudMetadataGaps';
import authorization from '../../util/authorization';
import { currencies } from '../currencyExchangeRule';
import addon from '../addon';
const PRICE_COMPONENT_FIELDS: PartialField[] = [{
  name: 'currency',
  options: currencies,
  inputType: 'niara-react-form/inputText',
  label: 'Moeda'
}, {
  name: 'value',
  type: 'float',
  label: 'Valor',
  inputType: 'niara-react-form/inputFloat',
  fractionDigits: 2,
  startAdornment: '$'
}];
export default fillCrudMetadataGaps<AddonReservation>({
  label: 'Reserva de Extra',
  labelPlural: 'Reservas de Extra',
  name: 'AddonReservation',
  namePlural: 'AddonReservations',
  authorization: authorization('clientConsultant', 'consultant'),
  deletable: false,
  // updatable: false,
  // insertable: false,
  custom_withAudit: true,
  custom_actionAuditOnUpdate: true,
  dynamoDB: {
    tableName: 'SpearAddonReservation',
    indexes: [{
      indexedProp: 'orderId',
      indexName: 'tenantId-orderId-index',
      scanIndexBackwards: true
    }, {
      indexedProp: 'addonId',
      indexName: 'tenantId-addonId-index',
      scanIndexBackwards: true
    }, {
      indexedProp: 'startDate',
      indexName: 'tenantId-startDate-index',
      scanIndexBackwards: true
    }, {
      indexedProp: 'scheduleDate',
      indexName: 'tenantId-scheduleDate-index',
      scanIndexBackwards: true
    }, {
      indexedProp: 'date',
      indexName: 'tenantId-date-index',
      scanIndexBackwards: true
    }]
  },
  columns: ['id', 'name', 'date', 'ownerId'],
  fields: [{
    label: 'Id',
    name: 'id',
    type: 'text',
    updatable: false,
    insertable: false,
    id: true,
    renderColumn: false
  }, {
    name: 'date',
    label: 'Data da reserva',
    type: 'datetime',
    updatable: false,
    custom_auditConfig: {
      show: 'NEVER'
    }
  }, {
    name: 'name',
    label: 'Nome',
    type: 'text',
    required: true
  }, {
    name: 'addon',
    label: 'detalhes do extra',
    type: 'object',
    fields: addon.fields,
    updatable: false
  }, {
    name: 'addonId',
    label: 'Extra cadastrado',
    type: 'text',
    updatable: false
  }, {
    name: 'orderId',
    label: 'Viagem',
    custom_auditConfig: {
      show: 'NEVER'
    },
    'custom:includeSelfHotelReservation': true,
    updatable: false
  }, {
    name: 'hotelReservationId',
    label: 'Reserva de hotel',
    updatable: false,
    custom_auditConfig: {
      show: 'NEVER'
    },
    'custom:includeSelfHotelReservation': true,
    deprecated: true
  }, {
    name: 'idOnSource',
    label: 'Localizador (conteúdo)',
    updatable: false,
    'custom:includeSelfHotelReservation': false,
    custom_auditConfig: {
      show: 'ON_CHANGE'
    },
    deprecated: true
  }, {
    name: 'ownerId',
    label: 'ID associado',
    hint: 'hotelReservation#{hotelReservationId}',
    custom_auditConfig: {
      show: 'NEVER'
    },
    'custom:includeSelfHotelReservation': true,
    updatable: false
  }, {
    name: 'locator',
    label: 'Localizador',
    hint: 'Localizador da reserva de hotel',
    'custom:includeSelfHotelReservation': true,
    custom_auditConfig: {
      show: 'ON_CHANGE'
    }
  }, {
    name: 'startDate',
    label: 'Data de início',
    type: 'datetime',
    updatable: false
  }, {
    name: 'endDate',
    label: 'Data de fim',
    type: 'datetime',
    updatable: false
  }, {
    name: 'cancelDate',
    label: 'Data de cancelamento',
    type: 'datetime',
    updatable: false,
    custom_auditConfig: {
      show: 'ON_CHANGE',
      sortOrder: 3
    }
  }, {
    name: 'status',
    label: 'Status',
    hint: 'Status da reserva',
    'custom:includeSelfHotelReservation': true,
    required: true,
    custom_auditConfig: {
      sortOrder: 3.01
    },
    // render: (i) => i.ImportedBy ? <div><span className="badge badge-pill badge-warning">I</span>{i.status}</div> : i.status
    options: [{
      label: 'Rejeitado',
      color: '#FF0000',
      value: 'REJECTED'
    }, {
      label: 'Confirmado',
      color: '#53AC2A',
      value: 'CONFIRMED'
    }, {
      label: 'Cancelado',
      color: '#FF0000',
      value: 'CANCELLED'
    }, {
      label: 'Em Processamento',
      color: '#FDBA01',
      value: 'PROCESSING',
      disabled: true
    }, {
      label: 'Solicitado',
      color: '#FDBA01',
      value: 'PRE_RESERVATION'
    }],
    renderStyle(i, fieldName = 'status') {
      if (i[fieldName]) {
        switch (i[fieldName]) {
          case 'CANCELLED':
          case 'REJECTED':
          case 'UNCONFIRMED':
            return 'danger';
          case 'PRE_RESERVATION':
          case 'PROCESSING':
          case 'MODIFIED':
          case 'PENDING_PAYMENT':
            return 'warning';
          case 'CONFIRMED':
            return 'success';
        }
      }
      return 'danger';
    }
  }, {
    name: 'enabled',
    label: 'Ativo',
    default: false,
    updatable: false,
    type: 'boolean',
    deprecated: true
  }, {
    name: 'totalPrice',
    label: 'Valor total',
    type: 'float'
  }, {
    name: 'totalReservationReceivable',
    label: 'Total a receber',
    type: 'float',
    inputType: 'niara-react-form/inputFloat',
    fractionDigits: 2,
    startAdornment: '$'
  }, {
    name: 'totalReservationReceiveCurrency',
    label: 'Moeda total a receber',
    options: currencies,
    inputType: 'niara-react-form/inputText'
  }, {
    name: 'totalReservationReceived',
    hint: 'Total Recebido',
    label: 'Valor',
    type: 'float',
    updatable: false
  }, {
    name: 'totalReservationPreConfirmed',
    label: 'Total Pré Confirmado',
    type: 'float',
    fractionDigits: 2,
    updatable: false
  }, {
    name: 'price',
    type: 'object',
    label: 'Componentes do preço',
    hint: 'Preço de venda',
    custom_renderFieldsRecursively: true,
    fields: [{
      name: 'total',
      label: 'Valor total',
      hint: 'Preço de venda total, incluindo taxas, impostos, descontos, markup.',
      type: 'object',
      custom_auditConfig: {
        sortOrder: 25
      },
      fields: PRICE_COMPONENT_FIELDS,
      render: entity => entity?.total?.value ? printPrice(entity?.total?.value, entity?.total?.currency) : undefined
    }, {
      name: 'recurringPayment',
      label: 'Pagamento recorrente',
      hint: 'Valor do pagamento recorrente',
      type: 'object',
      fields: PRICE_COMPONENT_FIELDS,
      custom_auditConfig: {
        sortOrder: 17.08
      },
      updatable: false
    }]
  }, {
    label: 'Nome do motor de Regras',
    name: 'engineRuleName',
    updatable: false
  }, {
    label: 'Id do motor de Regras',
    name: 'engineRuleId',
    updatable: false
  }, {
    label: 'ID purchase session',
    name: 'purchaseSessionId',
    updatable: false
  }, {
    name: 'extraFields',
    label: 'Campos Extras',
    type: 'objectarray',
    inputType: 'InputObjectArray',
    custom_renderFieldsRecursively: true,
    custom_auditConfig: {
      groupName: 'Campos extras',
      sortOrder: 1000
    },
    fields: [{
      name: 'label',
      label: 'Nome de exibição',
      type: 'text',
      readOnly: true
    }, {
      name: 'name',
      label: 'Name',
      type: 'text',
      custom_auditConfig: {
        show: 'NEVER'
      },
      renderForm: false
    }, {
      name: 'valueStr',
      label: 'Valor tipo texto',
      type: 'text'
    }, {
      name: 'valueInt',
      label: 'Valor tipo inteiro',
      type: 'int'
    }]
  }, {
    label: 'Data do agendamento',
    name: 'scheduleDate',
    type: 'datetime'
  }, {
    label: 'Hora do agendamento',
    name: 'scheduleTime'
  }, {
    label: 'Comentários',
    name: 'comments',
    inputType: 'textarea'
  }, {
    label: 'Nome do addon',
    name: 'addonName',
    updatable: false
  }, {
    label: 'Tipo do addon',
    name: 'addonType',
    updatable: false
  }, {
    label: 'ID da variante',
    name: 'variantId',
    updatable: false
  }, {
    label: 'Categoria',
    name: 'variantLabel'
  }, {
    label: 'Data da notificação de lembrete do addon',
    name: 'notificationReminderDatetime',
    type: 'datetime',
    updatable: false
  }, {
    label: 'Data do cancelamento automático',
    name: 'automaticCancellationDate',
    type: 'datetime',
    updatable: false
  }, {
    label: 'Compra obrigatória',
    name: 'mandatoryPurchase',
    type: 'boolean',
    updatable: false
  }, {
    label: 'Tipo de cobrança',
    name: 'billingType',
    options: [{
      label: 'Por mês',
      value: 'BILLING_TYPE_PER_MONTH'
    }, {
      label: 'Por dia',
      value: 'BILLING_TYPE_PER_DAY'
    }, {
      label: 'Por unidade',
      value: 'BILLING_TYPE_PER_UNIT'
    }],
    updatable: false
  }],
  filter: [{
    name: 'enabled_eq',
    field: 'enabled',
    op: 'eq'
  }, {
    field: 'orderId',
    op: 'eq'
  }, {
    field: 'addonId',
    op: 'eq'
  }, {
    name: 'date_eq',
    field: 'date',
    op: 'eq'
  }, {
    name: 'date_le',
    field: 'date',
    op: 'le'
  }, {
    name: 'date_ge',
    field: 'date',
    op: 'ge'
  }, {
    name: 'startDate_le',
    field: 'startDate',
    op: 'le'
  }, {
    name: 'startDate_ge',
    field: 'startDate',
    op: 'ge'
  }, {
    name: 'endDate_le',
    field: 'endDate',
    op: 'le'
  }, {
    name: 'endDate_ge',
    field: 'endDate',
    op: 'ge'
  }, {
    name: 'scheduleDate_le',
    field: 'scheduleDate',
    op: 'le'
  }, {
    name: 'scheduleDate_ge',
    field: 'scheduleDate',
    op: 'ge'
  }, {
    name: 'scheduleTime_le',
    field: 'scheduleTime',
    op: 'le'
  }, {
    name: 'scheduleTime_ge',
    field: 'scheduleTime',
    op: 'ge'
  }, {
    name: 'cancelDate_le',
    field: 'cancelDate',
    op: 'le'
  }, {
    name: 'cancelDate_ge',
    field: 'cancelDate',
    op: 'ge'
  }, {
    name: 'addonType_eq',
    field: 'addonType',
    op: 'eq'
  }, {
    name: 'comments_isNull',
    field: 'comments',
    op: 'isNull'
  }]
});